export default __webpack_public_path__ + "static/media/recipe.085e5cc9.png";